@let info = infoSg();

<fa-icon
  [icon]="info.icon"
  [style.color]="info.color"
  class="atn-ds-file-icon"
>
</fa-icon>
